import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=061f6bfc&"
import script from "./Appointment.vue?vue&type=script&lang=js&"
export * from "./Appointment.vue?vue&type=script&lang=js&"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=061f6bfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports